import { VCard } from 'vuetify/lib/components/VCard';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        _setup.DialogBottomSheet,
        {
          attrs: {
            "is-visible": _setup.isDialogOpened,
            width: _setup.isMobile ? undefined : 375,
            "content-class": "rounded-0",
          },
          on: {
            input: _setup.filtersStore.resetUnsavedFilters,
            "dialog-bottom-sheet:change-visible": _setup.closeDialog,
          },
        },
        [
          _c(
            VCard,
            { staticClass: "pt-6 px-4 pb-4", attrs: { tile: "" } },
            [
              _c("div", { staticClass: "text-h6 mb-2" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_setup.t("Время работы", _setup.options)) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(_setup.TimeWorkSelector, {
                model: {
                  value: _setup.filtersStore.unsavedFilters,
                  callback: function ($$v) {
                    _vm.$set(_setup.filtersStore, "unsavedFilters", $$v)
                  },
                  expression: "filtersStore.unsavedFilters",
                },
              }),
              _vm._v(" "),
              _c(_setup.BtnApplyFilters, {
                staticClass: "mt-4",
                attrs: {
                  active: _setup.isDialogOpened,
                  "trigger-request": _setup.triggerUpdateLpuCount,
                },
                on: {
                  "click:submit": _setup.applySelectedTimeWork,
                  "click:close": _setup.closeDialog,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }